'use client'

import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'

// Do not auto-initialize PostHog - it will be initialized conditionally based on consent
// in ConditionalAnalytics component

export function PHProvider({ children }: { children: React.ReactNode }) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>
}